import {Component, OnInit} from '@angular/core';
import {takeUntil} from 'rxjs/operators';

import {ESSService} from '../../+ess/employee-self.service';
import {Destroyable} from '../../destroyable.component';
import {ReportDefinition, ReportsFormData} from '../../models/models.interfaces';
import {ProfileMode} from '../../app.constants';


@Component({
  selector: 'gp-my-team-reports',
  templateUrl: './my-team-reports.component.html'
})
export class MyTeamReportsComponent extends Destroyable implements OnInit {

  public static ACCESS_NAME: string = 'MyTeamReports';
  reportTypesToFetch = ['MSS'];
  public profileMode = ProfileMode.MSS;

  cliRegId: number = null;
  reports: Array<ReportDefinition>;
  selectedReport: ReportDefinition;
  hiddenValuesForReportDefinition = new Map();

  constructor(private essService: ESSService) {
    super();
  }

  ngOnInit() {
    this.essService.currentUser
      .pipe(
        takeUntil(this.componentDestroyed$)
      )
      .subscribe(() => {
        const employee = this.essService.employee;
        if (employee) {
          const mainContract = employee.contracts.find(contract => contract.mainContract);
          this.cliRegId = mainContract.cliRegID;
          this.hiddenValuesForReportDefinition.set('mssEmployeeId', employee.id);
        }
      });
  }

  public reportsLoaded(reports: ReportsFormData) {
    this.reports = reports.data;
  }

  public reportListener(event: { reportDefinition: ReportDefinition, status: string }) {
    this.selectedReport = null;
  }

  public onReportSelection(selectedReport: ReportDefinition): void {
    this.selectedReport = selectedReport;
  }
}
